module.exports = __webpack_public_path__ + "static/media/21KM.94378975.webp";